module.exports = __webpack_public_path__ + "static/img/icon_back.b31187d3.svg";